import React, { useState } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import theme from './styles/theme';
import AppLayout from './components/AppLayout';
import HomePage from './components/HomePage';

type Page = 'home' | 'eligibility' | 'assessments';
type Track = 'cloud' | 'data' | null;

function App() {
  const [currentPage, setCurrentPage] = useState<Page>('home');
  const [selectedTrack, setSelectedTrack] = useState<Track>(null);

  const handleLogoClick = () => {
    setCurrentPage('home');
    setSelectedTrack(null);
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AppLayout onLogoClick={handleLogoClick}>
        <HomePage
          currentPage={currentPage}
          selectedTrack={selectedTrack}
          setCurrentPage={setCurrentPage}
          setSelectedTrack={setSelectedTrack}
        />
      </AppLayout>
    </ThemeProvider>
  );
}

export default App;

